import { IFormValues } from './types';

const initialValues: IFormValues = {
  programId: null,
};

export default initialValues;
